<template>
  <md-dialog
    ref="dialog"
    :md-click-outside-to-close="false"
    :md-esc-to-close="true"
    class="microbiology-partial-details-modal"
  >
    <md-dialog-content>
      <div class="partial-details">
        <div class="partial-details__header">
          <h3>
            Microorganismo:
            <strong>{{ details.microorganism }}</strong>
          </h3>
          <button
            class="partial-details__close"
            @click="close"
          >
            <md-icon>clear</md-icon>
          </button>
        </div>

        <div class="partial-details__body">
          <div class="partial-details__left">
            <div class="partial-details__date">{{ details.reportDate }}</div>
            <p class="partial-details__subtitle">
              Resultados e Concentracao Inibitoria Minima (C.I.M) em {{ details.unit }}
            </p>

            <h4>{{ details.microorganism }}</h4>

            <table class="partial-details__table">
              <thead>
                <tr>
                  <th>Antibiograma</th>
                  <th>Resultado</th>
                  <th>C.I.M</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in details.rows"
                  :key="`abg-${index}`"
                >
                  <td>{{ item.antibiogram }}</td>
                  <td>{{ item.result }}</td>
                  <td>{{ item.cim }}</td>
                </tr>
              </tbody>
            </table>

            <p class="partial-details__footer-note">{{ details.footerNote }}</p>
          </div>

          <div class="partial-details__right">
            <h4>Notas:</h4>
            <div
              v-for="(note, index) in details.notes"
              :key="`note-${index}`"
              class="partial-details__note"
            >
              <strong>{{ note.title }}</strong>
              <p>{{ note.text }}</p>
            </div>
          </div>

          <div class="partial-details__watermark">PARCIAL</div>
        </div>
      </div>
    </md-dialog-content>
  </md-dialog>
</template>

<script>
export default {
  name: 'PartialDetailsModal',
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  methods: {
    open() {
      this.$refs.dialog.open()
    },
    close() {
      this.$refs.dialog.close()
    },
  },
}
</script>

<style lang="scss">
.microbiology-partial-details-modal .md-dialog {
  width: 1040px;
  max-width: calc(100vw - 30px);
  border-radius: 10px;
}

.microbiology-partial-details-modal .partial-details__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ddd;
  padding: 6px 6px 14px;
}

.microbiology-partial-details-modal .partial-details__header h3 {
  margin: 0;
  color: #757575;
  font-size: 22px;
}

.microbiology-partial-details-modal .partial-details__header h3 strong {
  color: #404040;
  font-weight: 700;
}

.microbiology-partial-details-modal .partial-details__close {
  border: none;
  background: transparent;
  color: #8e8e8e;
  cursor: pointer;
}

.microbiology-partial-details-modal .partial-details__body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 520px;
  position: relative;
  overflow: hidden;
}

.microbiology-partial-details-modal .partial-details__left {
  padding: 24px 24px 18px;
  position: relative;
  background: #fff;
  z-index: 3;
}

.microbiology-partial-details-modal .partial-details__right {
  padding: 24px;
  background: #f6f3ec;
  z-index: 3;
}

.microbiology-partial-details-modal .partial-details__right h4 {
  margin-top: 0;
}

.microbiology-partial-details-modal .partial-details__date {
  font-size: 22px;
  font-weight: 700;
  color: #4e4e4e;
  margin-bottom: 10px;
}

.microbiology-partial-details-modal .partial-details__subtitle {
  font-style: italic;
  color: #7c7c7c;
  margin: 0 0 16px;
  font-size: 16px;
}

.microbiology-partial-details-modal h4 {
  margin: 0 0 14px;
  font-size: 18px;
  color: #4e4e4e;
}

.microbiology-partial-details-modal .partial-details__table {
  width: 100%;
  border-collapse: collapse;
}

.microbiology-partial-details-modal .partial-details__table th,
.microbiology-partial-details-modal .partial-details__table td {
  text-align: left;
  padding: 6px 4px;
}

.microbiology-partial-details-modal .partial-details__table th {
  font-weight: 500;
  color: #666;
}

.microbiology-partial-details-modal .partial-details__table td {
  color: #4d4d4d;
  font-weight: 700;
}

.microbiology-partial-details-modal .partial-details__footer-note {
  margin-top: 14px;
  color: #666;
  font-weight: 700;
  font-size: 14px;
}

.microbiology-partial-details-modal .partial-details__note {
  margin-bottom: 16px;
}

.microbiology-partial-details-modal .partial-details__note strong {
  color: #4d4d4d;
}

.microbiology-partial-details-modal .partial-details__note p {
  margin: 4px 0 0;
  color: #616161;
  line-height: 1.4;
}

.microbiology-partial-details-modal .partial-details__watermark {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) rotate(-28deg);
  font-size: 170px;
  color: rgba(214, 179, 99, 0.38);
  font-weight: 700;
  pointer-events: none;
  user-select: none;
  z-index: 3;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .microbiology-partial-details-modal .partial-details__body {
    grid-template-columns: 1fr;
  }

  .microbiology-partial-details-modal .partial-details__watermark {
    font-size: 88px;
  }
}
</style>
